module.exports = __webpack_public_path__ + "img/ghost.4648661a.svg";